import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../request.js";
import { isSome as e } from "../../../core/maybe.js";
import { join as r, urlToObject as n } from "../../../core/urlUtils.js";
import { getJsonType as i } from "../../../geometry/support/jsonUtils.js";
import { normalizeCentralMeridian as o } from "../../../geometry/support/normalizeUtils.js";
import { isHostedAgolService as s } from "../../../layers/support/arcgisLayerUrl.js";
import { parsePBFFeatureQuery as a } from "./pbfQueryUtils.js";
import { applyFeatureSetZUnitScaling as u } from "./queryZScale.js";
import { mapParameters as l } from "../../../tasks/operations/urlUtils.js";
var m = "Layer does not support extent calculation.";

function y(t, r) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var o = t.geometry,
      s = t.toJSON(),
      a = s,
      u = t.outSpatialReference;
  var l, m;

  if (e(o)) {
    if (l = o.spatialReference, m = o.spatialReference.wkid || JSON.stringify(o.spatialReference), a.geometryType = i(o), n && "extent" === o.type) a.geometry = "".concat(o.xmin, ",").concat(o.ymin, ",").concat(o.xmax, ",").concat(o.ymax);else if (n && "point" === o.type) a.geometry = "".concat(o.x, ",").concat(o.y);else {
      var _t = o.toJSON();

      delete _t.spatialReference, a.geometry = JSON.stringify(_t);
    }
    a.inSR = m;
  }

  if (l || (l = u), s.groupByFieldsForStatistics && (a.groupByFieldsForStatistics = s.groupByFieldsForStatistics.join(",")), s.objectIds && (a.objectIds = s.objectIds.join(",")), s.orderByFields && (a.orderByFields = s.orderByFields.join(",")), !s.outFields || !s.returnDistinctValues && (null != r && r.returnCountOnly || null != r && r.returnExtentOnly || null != r && r.returnIdsOnly) ? delete a.outFields : -1 !== s.outFields.indexOf("*") ? a.outFields = "*" : a.outFields = s.outFields.join(","), s.outSR ? a.outSR = s.outSR.wkid || JSON.stringify(s.outSR) : o && (s.returnGeometry || s.returnCentroid) && (a.outSR = a.inSR), s.returnGeometry && delete s.returnGeometry, s.outStatistics && (a.outStatistics = JSON.stringify(s.outStatistics)), s.pixelSize && (a.pixelSize = JSON.stringify(s.pixelSize)), s.quantizationParameters && (n && e(l) && e(t.quantizationParameters) && e(t.quantizationParameters.extent) && l.equals(t.quantizationParameters.extent.spatialReference) && delete s.quantizationParameters.extent.spatialReference, a.quantizationParameters = JSON.stringify(s.quantizationParameters)), s.parameterValues && (a.parameterValues = JSON.stringify(s.parameterValues)), s.rangeValues && (a.rangeValues = JSON.stringify(s.rangeValues)), s.dynamicDataSource && (a.layer = JSON.stringify({
    source: s.dynamicDataSource
  }), delete s.dynamicDataSource), s.timeExtent) {
    var _t2 = s.timeExtent,
        _e = _t2.start,
        _r = _t2.end;
    null == _e && null == _r || (a.time = _e === _r ? _e : "".concat(null == _e ? "null" : _e, ",").concat(null == _r ? "null" : _r)), delete s.timeExtent;
  }

  return a;
}

function c(_x, _x2, _x3, _x4) {
  return _c.apply(this, arguments);
}

function _c() {
  _c = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, r, n, i) {
    var o;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(e(r.timeExtent) && r.timeExtent.isEmpty)) {
              _context.next = 4;
              break;
            }

            _context.t0 = {
              data: {
                features: []
              }
            };
            _context.next = 7;
            break;

          case 4:
            _context.next = 6;
            return g(t, r, "json", i);

          case 6:
            _context.t0 = _context.sent;

          case 7:
            o = _context.t0;
            return _context.abrupt("return", (u(r, n, o.data), o));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _c.apply(this, arguments);
}

function p(_x5, _x6, _x7, _x8) {
  return _p.apply(this, arguments);
}

function _p() {
  _p = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, r, n, i) {
    var o, s;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(e(r.timeExtent) && r.timeExtent.isEmpty)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", Promise.resolve({
              data: n.createFeatureResult()
            }));

          case 2:
            _context2.next = 4;
            return f(t, r, i);

          case 4:
            o = _context2.sent;
            s = o;
            return _context2.abrupt("return", (s.data = a(o.data, n), s));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _p.apply(this, arguments);
}

function f(t, e, r) {
  return g(t, e, "pbf", r);
}

function d(t, r, n) {
  return e(r.timeExtent) && r.timeExtent.isEmpty ? Promise.resolve({
    data: {
      objectIds: []
    }
  }) : g(t, r, "json", n, {
    returnIdsOnly: !0
  });
}

function x(t, r, n) {
  return e(r.timeExtent) && r.timeExtent.isEmpty ? Promise.resolve({
    data: {
      count: 0
    }
  }) : g(t, r, "json", n, {
    returnIdsOnly: !0,
    returnCountOnly: !0
  });
}

function S(t, r, n) {
  return e(r.timeExtent) && r.timeExtent.isEmpty ? Promise.resolve({
    data: {
      count: 0,
      extent: null
    }
  }) : g(t, r, "json", n, {
    returnExtentOnly: !0,
    returnCountOnly: !0
  }).then(function (t) {
    var e = t.data;
    if (e.hasOwnProperty("extent")) return t;
    if (e.features) throw new Error(m);
    if (e.hasOwnProperty("count")) throw new Error(m);
    return t;
  });
}

function g(i, a, u) {
  var m = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var p = "string" == typeof i ? n(i) : i,
      f = a.geometry ? [a.geometry] : [];
  return m.responseType = "pbf" === u ? "array-buffer" : "json", o(f, null, m).then(function (n) {
    var i = n && n[0];
    e(i) && ((a = a.clone()).geometry = i);
    var o = s(p.path),
        f = l(_objectSpread(_objectSpread(_objectSpread({}, p.query), {}, {
      f: u
    }, c), y(a, c, o)));
    return t(r(p.path, "query"), _objectSpread(_objectSpread({}, m), {}, {
      query: _objectSpread(_objectSpread({}, f), m.query)
    }));
  });
}

export { c as executeQuery, x as executeQueryForCount, S as executeQueryForExtent, d as executeQueryForIds, p as executeQueryPBF, f as executeQueryPBFBuffer, y as queryToQueryStringParameters, g as runQuery };